<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-12-01 11:57:46
-->
<template>
</template>

<script>
// import * as echarts from "echarts";
export default {
  data () {
    return {
      valueKq: "",//考勤日期范围
      valueKs: "",//课时日期范围
      tongInfo: {
        bantiancount: [],
        fb_student: "",
        kqdate: [],
        ksdata: [],
        ksdate: [],
        lingxingcount: [],
        nian_grade: [],
        nian_sdudent: [],
        nian_teacher: [],
        nofb_student: "",
        nopz_student: "",
        nopz_teacher: "",
        pz_student: "",
        pz_teacher: "",
        total_grade: "",
        total_teacher: "",
        zx_student: "",
        zx_teacher: ""
      },//统计数据
      ksDate: [],
      ksSeries: [],
      kqstart_time: "",
      kqend_time: "",
      ksstart_time: "",
      ksend_time: ""
    };
  },
  created () {
  },
  methods: {
  },
  mounted () {
  },
  updated () {
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}

.page-top {
  width: 100%;
  height: 0.92rem;
  margin-bottom: 0.06rem;
  padding: 0.11rem 0 0.11rem 0.16rem;
  background-image: url(../../../public/img/topFl.png);
  background-repeat: no-repeat;
  background-position: bottom right 0.12rem;
  background-size: 0.92rem;
  background-color: #fff;
}

.page-title {
  margin-right: 0.2rem;
  font-size: 0.08rem;
  color: #000;
  position: relative;
  padding-left: 0.06rem;
  line-height: 0.07rem;
}

.page-title::before {
  content: "";
  position: absolute;
  width: 0.02rem;
  height: 0.07rem;
  background: #f87e35;
  top: 0;
  left: 0;
}

.page-top .top-tong {
  display: flex;
  align-items: center;
}

.page-top .top-tong .tong-item {
  font-size: 0.08rem;
  color: #000;
  margin-right: 0.17rem;
}

.page-top .top-tong .tong-item span {
  font-size: 0.1rem;
  font-weight: 600;
}

.page-top .top-nav {
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
}

.page-top .top-nav .nav-item {
  display: flex;
  align-items: center;
  width: 1.39rem;
  height: 0.52rem;
  padding-left: 0.15rem;
  margin-right: 0.13rem;
  border-radius: 0.03rem;
  overflow: hidden;
}

.page-top .top-nav .nav-item .item-desc span {
  display: block;
}

.page-top .top-nav .nav-item.itema {
  background: url(../../../public/img/back1.png) no-repeat;
  background-size: 100%;
}

.page-top .top-nav .nav-item.itemb {
  background: url(../../../public/img/back2.png) no-repeat;
  background-size: 100%;
}

.page-top .top-nav .nav-item.itemc {
  background: url(../../../public/img/back3.png) no-repeat;
  background-size: 100%;
}

.page-top .top-nav .nav-item.itemd {
  background: url(../../../public/img/back4.png) no-repeat;
  background-size: 100%;
}

.page-top .top-nav .nav-item.iteme {
  background: url(../../../public/img/back5.png) no-repeat;
  background-size: 100%;
}

.page-top .top-nav .nav-item .icon {
  width: 0.29rem;
  height: 0.29rem;
  margin-right: 0.08rem;
}

.page-top .top-nav .nav-item .item-desc .desc {
  font-size: 0.08rem;
  color: #333;
  line-height: 0.08rem;
  margin-bottom: 0.07rem;
}

.page-top .top-nav .nav-item .item-desc .num {
  color: #000;
  font-size: 0.1rem;
  line-height: 0.1rem;
}

.page-center {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0.05rem;
}

.page-center .center-tong {
  background: #fff;
  border-radius: 0.02rem;
  width: 49.7%;
  height: 1.77rem;
  padding: 0.11rem 0.16rem;
}

.page-center .tong-con {
  display: flex;
  //   margin-top: 0.27rem;
  margin-bottom: 0.04rem;
  height: 1.6rem;
}

.page-center .tong-con .con-fl {
  width: 1.28rem;
  padding-top: 0.27rem;
}

.page-center .tong-con .con-fr {
  flex: 1;
}

.page-center .tong-con .fl-line {
  background: #fff6ee;
  border-radius: 0.03rem;
  width: 1.28rem;
  line-height: 0.27rem;
  margin-bottom: 0.14rem;
  padding-left: 0.23rem;
  color: #333;
  font-size: 0.08rem;
}

.page-center .tong-con .fl-line span {
  font-size: 0.1rem;
  color: #f87e35;
}

.page-bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.page-bottom .center-tong {
  background: #fff;
  border-radius: 0.02rem;
  // width: 32.93%;
  width: 49.7%;
  height: 2.19rem;
  padding: 0.11rem 0.16rem;
}

.dis {
  display: flex;
  align-items: center;
}

.page-bottom .tong-con {
  height: 2rem;
  // display: flex;
  // flex-direction: column;
}

.page-bottom .con-search {
  width: 100%;
  height: 0.21rem;
  margin-top: 0.08rem;
}

.page-bottom .con-biao {
  width: 100%;
  height: 1.72rem;
}

.page-bottom .tong-con .yue {
  width: 0.3rem;
  line-height: 0.21rem;
  text-align: center;
  border-radius: 0.03rem;
  border: 1px solid #d9d9db;
  margin-left: 0.04rem;
  font-size: 0.08rem;
  color: #666666;
  white-space: nowrap;
  cursor: pointer;
}

.page-bottom .tong-con .searchBtn {
  width: 0.42rem;
  height: 0.21rem;
  display: flex;
  align-items: center;
}

.page-bottom .tong-con .searchBtn .el-button {
  width: 0.42rem;
  height: 0.21rem;
  padding: 0;
  margin-left: 0.07rem;
}

.page-bottom .tong-con .searchBtn /deep/.el-button .el-icon-search {
  font-size: 0.08rem;
}

.page-bottom .tong-con .searchBtn /deep/.el-button span {
  font-size: 0.08rem;
  margin-left: 0.01rem;
}

.page-bottom .tong-con .el-date-editor {
  width: 1.54rem;
  height: 0.21rem;
  padding: 0 0 0 0.03rem;
  font-size: 0.08rem;
}

.page-bottom .tong-con /deep/.el-date-editor .el-input__icon {
  line-height: 0.21rem !important;
}

.page-bottom .tong-con /deep/.el-date-editor .el-range-separator {
  line-height: 0.21rem !important;
}
</style>
